


















































































































import { Vue, Component } from "vue-property-decorator";
import Modal from "@/components/widgets/molecules/Modal/Modal.vue";
import ButtonCustom from "@/components/widgets/atoms/ButtonCustom/ButtonCustom.vue";
import ButtonPictures from "@/components/widgets/atoms/ButtonPictures/ButtonPictures.vue";

import getMaskDefinition from "@/shared/util/masks";

import {
  TRANSIT_REGISTER_POST_CART,
  TRANSIT_REGISTER_PUT_CART,
  SELECT_REGISTER_CART,
  TRANSIT_REGISTER_GET_SKETCH_CART,
} from "@/store/TransitFacility/registers/actions";

import { GET_UF_REQUEST } from "@/store/locations/actions";

@Component({
  components: {
    Modal,
    ButtonCustom,
    ButtonPictures
  },
})

export default class NewCartModal extends Vue {
  private hasHeiferOptions: any = [
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' },
  ]

  // private truckTypeOptions: any =[
  //   { value: null, text: 'Selecione', disabled: true },
  //   { value: 'Cavalo 4x2', text: 'Cavalo 4x2' },
  //   { value: 'Cavalo 6x2', text: 'Cavalo 6x2' },
  //   { value: 'Cavalo 6x4', text: 'Cavalo 6x4' },
  //   { value: 'Truck 6x2', text: 'Truck 6x2' },
  //   { value: 'Truck 6x4', text: 'Truck 6x4' },
  //   { value: 'Bitruck 8x2', text: 'Bitruck 8x2' },
  //   { value: 'Bitruck 8x4', text: 'Bitruck 8x4' },
  //   { value: 'Toco', text: 'Toco' },
  //   { value: '3/4', text: '3/4' },
  //   { value: 'Caminhonete', text: 'Caminhonete' },
  //   { value: 'Outro', text: 'Outro' },
  // ]

  private truckTypeOptions: any = [
    { value: null, text: 'Selecione', disabled: true },
    { value: '3 Eixos', text: '3 Eixos' },
    { value: '2 Eixos Alta', text: '2 Eixos Alta' },
    { value: 'Carreta Baixa', text: 'Carreta Baixa' },
    { value: 'Romeu e Julieta', text: 'Romeu e Julieta' },
    { value: 'Truck', text: 'Truck' },
  ]

  private brandOptions: any =[
    { value: null, text: 'Selecione', disabled: true },
    { value: 'FORD', text: 'FORD' },
    { value: 'IVECO', text: 'IVECO' },
    { value: 'MERCEDES', text: 'MERCEDES' },
    { value: 'SCANIA', text: 'SCANIA' },
    { value: 'VOLKSWAGEN', text: 'VOLKSWAGEN' },
    { value: 'VOLVO', text: 'VOLVO' },
    { value: 'OUTRO', text: 'OUTRO' },
  ]

  private licensePlateUFOptions: any =[]

  private selectedOptions: any = {
    licensePlateUF: null,
    licensePlateNumber: '',
    truckType: null,
    brand: null,
    compartments: '',
    capacity: '',
    hasHeifer: true,
    descriptionChassi: '',
    descriptionRenavam: '',
    descriptionYear: '',
    selectedDriverSide: null,
    selectedRideSide: null,
    selectedBackSide: null,
    selectedEnclosuresSide: null,
  };

  private isLoading: boolean = false;

  private busy: boolean = false;

  /* Computed */
  get showModal() {
    return this.$store.getters.hasSelectedRegisterCart;
  }
  get selectedCart() {
    return this.$store.getters.getRegisterCart;
  }

  /* Methods */
  resetInfo(){
    this.selectedOptions = {
      licensePlateUF: null,
      licensePlateNumber: '',
      truckType: null,
      brand: null,
      compartments: '',
      capacity: '',
      hasHeifer: true,
      descriptionChassi: '',
      descriptionRenavam: '',
      descriptionYear: '',
      selectedDriverSide: null,
      selectedRideSide: null,
      selectedBackSide: null,
      selectedEnclosuresSide: null,
    };
    this.$store.dispatch(SELECT_REGISTER_CART, null);
  }

  initInfo(){
    this.getUF();
    if(this.showModal){
      this.isLoading = true;
      this.$store.dispatch(TRANSIT_REGISTER_GET_SKETCH_CART, this.selectedCart)
      .then((cart) => {
        this.selectedOptions = {
          licensePlateUF: cart?.uf || null,
          licensePlateNumber: cart?.placa || '',
          truckType: cart?.tipo || null,
          brand: cart?.marca || null,
          compartments: cart?.qtdCompartimentos || '',
          capacity: cart?.capacidade || '',
          hasHeifer: cart?.bezerreira || true,
          descriptionChassi: cart?.numeroChassi || '',
          descriptionRenavam: cart?.numeroRenavam || '',
          descriptionYear: cart?.ano || '',
          selectedDriverSide: null,
          selectedRideSide: null,
          selectedBackSide: null,
          selectedEnclosuresSide: null,
        };
        cart.fotos.forEach((foto) => {
          if(foto.descricao == "LATERAL_MOTORISTA"){
            this.selectedOptions.selectedDriverSide = foto.urlDocumento;
          }
          if(foto.descricao == "LATERAL_CARONA"){
            this.selectedOptions.selectedRideSide = foto.urlDocumento;
          }
          if(foto.descricao == "COMPARTIMENTO"){
            this.selectedOptions.selectedEnclosuresSide = foto.urlDocumento;
          }
          if(foto.descricao == "TRASEIRA"){
            this.selectedOptions.selectedBackSide = foto.urlDocumento;
          }
        });
      })
      .catch(() => {
        this.$toast.error("Erro ao carregar dados da carreta");
      }).finally(() => {
        this.isLoading = false;
      })
    }
  }
  
  getUF() {
    this.$store
    .dispatch(GET_UF_REQUEST)
    .then(result => {
      const UFs = result.data.map(({sigla}) => (
        {value: sigla, text: sigla}
      ));
      this.licensePlateUFOptions = UFs;
    })
    .catch(() => {
      this.$toast.error("Erro ao carregar os estados");
    })
  }

  maskDefinition(value) {
    return getMaskDefinition(value);
  }

  onErasePhoto(type){
    this.selectedOptions[type] = null;
  }

  onPhotoSelected(event, type){
    this.selectedOptions[type] = event.target.files[0]
  }

  createNewCart(){
    this.busy = true;
    const fd = new FormData();

    fd.append('UF', this.selectedOptions.licensePlateUF)
    fd.append('Placa', this.selectedOptions.licensePlateNumber)
    fd.append('Tipo', this.selectedOptions.truckType)
    fd.append('Marca', this.selectedOptions.brand)
    fd.append('QtdCompartimentos', this.selectedOptions.compartments)
    fd.append('Capacidade', this.selectedOptions.capacity)
    fd.append('Bezerreira', this.selectedOptions.hasHeifer)
    fd.append('NumeroChassi', this.selectedOptions.descriptionChassi)
    fd.append('NumeroRenavam', this.selectedOptions.descriptionRenavam)
    fd.append('Ano', this.selectedOptions.descriptionYear)
    fd.append('FotoLateralMotorista', this.selectedOptions.selectedDriverSide)
    fd.append('FotoLateralCarona', this.selectedOptions.selectedRideSide)
    fd.append('FotoTraseira', this.selectedOptions.selectedBackSide)
    fd.append('FotoCompartimentos', this.selectedOptions.selectedEnclosuresSide)

    if (this.showModal) {
      fd.append('IdCarreta', this.selectedCart)
      this.$store
        .dispatch(TRANSIT_REGISTER_PUT_CART, fd)
        .then(() => {
          this.$emit("message", "Carreta atualizada com sucesso", "success", true);
        })
        .catch(() => {
          this.$emit("message", "Erro ao atualizar carreta", "error");
        })
        .finally(() => {
          this.close();
          this.busy = false;
        });
      return;
    }

    this.$store
    .dispatch(TRANSIT_REGISTER_POST_CART, fd)
    .then(() => {
      this.$emit("message", "Carreta criada com sucesso", "success", true);
    })
    .catch(() => {
      this.$emit("message", "Erro ao criar nova carreta", "error");
    }).finally(() => {
      this.busy = false;
      this.close()
    })
  }

  close() {
    this.$bvModal.hide("NewCartModal");
  }
}
